import type { Schemas } from "#shopware";
import { useAddToCart as coreUseAddToCart } from "@shopware/composables";

export function useAddToCart(product: Ref<Schemas["Product"]>) {
  const coreFunctionality = coreUseAddToCart(product);
  const _product = computed(() => unref(product));

  const addToCart = async () => {
    const result = await coreFunctionality.addToCart();
    coreFunctionality.quantity.value = _product.value.purchaseSteps || 1;
    return result;
  };

  return {
    ...coreFunctionality,
    addToCart,
  };
}
